import { useState } from 'react';
import QuoteModal from './QuoteModal';

export default function Hero() {
  const [showForm, setShowForm] = useState(false);

  const scrollToSelection = () => {
    const element = document.getElementById('selection');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <section className="pt-32 pb-24 bg-white">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-4">
                Тельфер с уменьшенной строительной высотой (УСВ)
              </h1>
              <p className="text-base sm:text-lg text-gray-500 mb-8 leading-relaxed">
                Поставка, подбор и техническая поддержка. Грузоподъёмность от 0,5 до 10 тонн.
              </p>

              <ul className="space-y-4 mb-10">
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-1">
                    <i className="ri-checkbox-line text-[#1A2B4A] text-base"></i>
                  </div>
                  <span className="text-base text-gray-700 leading-relaxed">В наличии и под заказ</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-1">
                    <i className="ri-checkbox-line text-[#1A2B4A] text-base"></i>
                  </div>
                  <span className="text-base text-gray-700 leading-relaxed">Соответствие ГОСТ / ТР ТС</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-1">
                    <i className="ri-checkbox-line text-[#1A2B4A] text-base"></i>
                  </div>
                  <span className="text-base text-gray-700 leading-relaxed">Подбор под ТЗ</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-1">
                    <i className="ri-checkbox-line text-[#1A2B4A] text-base"></i>
                  </div>
                  <span className="text-base text-gray-700 leading-relaxed">Гарантия</span>
                </li>
              </ul>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                <button 
                  onClick={() => setShowForm(true)}
                  className="bg-[#1A2B4A] text-white px-8 h-[52px] text-base font-medium hover:bg-[#0F1A2E] transition-colors whitespace-nowrap cursor-pointer"
                >
                  Запросить КП
                </button>
                <button 
                  onClick={scrollToSelection}
                  className="bg-white text-[#1A2B4A] px-8 h-[52px] text-base font-medium border-2 border-[#1A2B4A] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Подобрать по параметрам
                </button>
              </div>
            </div>

            <div className="lg:col-span-5 flex justify-center lg:justify-end">
              <div className="w-full max-w-[400px] lg:w-[85%]">
                <img 
                  src="https://static.readdy.ai/image/1abc7f46dd99472a2aec050fdae7667e/170576ccec2da76b5a3aceb79a2de1c4.webp" 
                  alt="Тельфер с уменьшенной строительной высотой"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {showForm && <QuoteModal onClose={() => setShowForm(false)} />}
    </>
  );
}